module.exports = __webpack_public_path__ + "static/rs-logo-white-0666481a1f0ac56a11422a4bbd6907b7.svg";